import Janus from "@/assets/js/janus";

export function destroyJanusSession(session, { cleanupHandles = true } = {}) {
  if (!session) {
    return;
  }

  const sessionId = session.getSessionId?.();
  if (sessionId) {
    Janus.sessions.delete(sessionId);
  }

  try {
    session.destroy({
      cleanupHandles,
      notifyDestroyed: false,
      success: Janus.noop,
      error: Janus.noop,
    });
  } catch (error) {
    console.error("Failed to destroy Janus session:", error);
  }
}
